import ApiStore from './ApiStore';
import axios from 'axios';

class SearchStore extends ApiStore {
  constructor(){
    super();
  }

  searchEmployee(inputCode) {
    return this.wrapResponse(axios.get('/search/employee?code='+inputCode));
  }

  searchWork(inputCode) {    
    return this.wrapResponse(axios.get('/search/work?code='+inputCode));
  }


  searchPublicWork(workNo,employeeId,department,scanStatus) {
    let url= `public/workdoc/info?work_no=${workNo}&emp_id=${employeeId}&department=${department}&scan_status=${scanStatus}`
    console.log('searchPublicWork',url)
    return this.wrapResponse(axios.get(url));
  }

  loadProfile(){
    return this.wrapResponse(axios.get('/authen/profile'));
  }

  loadOrgList(completeFunc){
    
    axios.get('/authen/orglist')
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }
}

export default new SearchStore();



// WEBPACK FOOTER //
// ./src/stores/SearchStore.js